module.exports = __webpack_public_path__ + "img/left-luggage.4982fc06.png";